import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row} from 'reactstrap';
import {TT_CLOSE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import Separator from "../../../../components/Separator";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {menuService} from "../../../../jwt/_services";
import {SelectWithIcon} from "../../../../components/select/selectWithIcon";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {applicativeProvider} from "../../../../providers/applicativeProvider";

export const MenuSectionForm = forwardRef((props, ref) => {
    const path = props.path;

    const [icon, setIcon] = useState(   null);
    const [appId, setAppId] = useState( null);

    const [name, setName] = useState( null);
    const [code, setCode] = useState( null);
    const [url, setUrl] = useState( null);
    const [description, setDescription] = useState( null);
    const [categoryCode, setCategoryCode] = useState( null);

    const [editMode, setEditMode] = useState(false);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    const [modal, setModal] = useState(false);
    const [item, setItem] = useState(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(item);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item, _index, _module) {

            setItem( _item );
            setEditMode( !!_item?.id );

            setCode(_item?.code || '');
            setName(_item?.name || '');
            setUrl(_item?.url || '');
            setDescription(_item?.description || '');
            setCategoryCode(_item?.categoryCode || '');
            setIcon(_item?.icon || '');
            setAppId(_item?.app?.id || null);

            setModal(!modal);
        }
    }));


    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------
    const onSubmit = (_) => {
        let dataRequest = {
            code,
            name,
            url,
            description,
            categoryCode
        }

        if (icon)
            dataRequest.icon =  icon.id;

        if (appId)
            dataRequest.app = { id : appId }
        else
            dataRequest.app = null

        if (!editMode) {
            console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, menuService, dataRequest)
        }
        else {
            let id = item?.menu?.id;
            dataRequest.id = item?.menu?.id;

            console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, menuService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        setModal(!modal);
    }


    return (<>
            <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
                <Card  className={'card-modal'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { (item?.title || item?.name || '') }</h2>
                            <br />
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                toolTip={TT_SAVE}
                                icon={'fa-save'}
                                permission={'add'}
                                onClick={onSubmit}
                            />
                            {
                                // editMode && userIsAdmin && <GenericButton
                                //     style={'table'}
                                //     toolTip={TT_HISTORY}
                                //     icon={'fa-clock'}
                                //     permission={'search'}
                                //     onClick={showHistory}
                                // />
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label >Codigo</Label>
                                    <Input type="text"
                                           name="code"
                                           placeholder="{app}_{clase}"
                                           value={code}
                                           onChange={ e => setCode(e.target.value) }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label >Nombre</Label>
                                    <Input type="text"
                                           name="name"
                                           placeholder="Ingrese nombre"
                                           value={name}
                                           onChange={ e => setName(e.target.value) }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label >Componente</Label>
                                    <Input type="text"
                                           name="url"
                                           placeholder="Identificador de vista"
                                             value={url}
                                             onChange={ e => setUrl(e.target.value) }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Icono</Label>
                                    <SelectWithIcon name="icon"
                                                    value={icon}
                                                    onChange={ value => setIcon(value) }/>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>App</Label>
                                    <br/>
                                    <SelectGeneric
                                        initialValue={ appId }
                                        setExternalValue={ setAppId }
                                        provider={ applicativeProvider }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Codigo de Categoria agrupadora</Label>
                                    <Input type="text"
                                           name="categoryCode"
                                           placeholder="Ingrese codigo"
                                           value={categoryCode}
                                           onChange={ e => setCategoryCode(e.target.value) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Descripción</Label>
                                    <Input type="textarea"
                                           rows="5"
                                           name="description"
                                           placeholder="Ingrese una descripción"
                                            value={description}
                                           onChange={ e => setDescription(e.target.value) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>




                        <Row>
                            <Col md="6">
                            </Col>
                            <Col md="6">
                                <Row>
                                </Row>
                            </Col>
                        </Row>

                    </CardBody>
                    {
                        showModal && <LogHistoryModal
                            ref={ modalRef }
                            item={ item }
                        />
                    }
                </Card>
            </Modal>
        </>
    )
})
